import type { APIPolicyOverviewApplicationFile } from 'types/api.types';
import Storage from 'storage';

export const getUserName = (user: APIPolicyOverviewApplicationFile['user']) => {
  if (!user) return 'Customer';

  return `${user.first_name} ${user.last_name}`;
};

export const isApiUrl = (url: string): boolean => url.includes('/api/');

export const fetchFileWithAuth = async (url: string): Promise<Blob> => {
  const token = Storage.get('user')?.token;
  const response = await fetch(url, {
    headers: token ? { User: token } : {},
  });
  if (!response.ok) throw new Error('Request failed');
  return response.blob();
};

export const openFileWithAuth = async (url: string): Promise<void> => {
  const blob = await fetchFileWithAuth(url);
  const blobUrl = URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');
};

export const downloadFileWithAuth = async (
  url: string,
  filename: string,
): Promise<void> => {
  const blob = await fetchFileWithAuth(url);
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(blobUrl);
};
